import { render, staticRenderFns } from "./PersonalAccountDocUploadForm.vue?vue&type=template&id=1bd3cd36&scoped=true&"
import script from "./PersonalAccountDocUploadForm.vue?vue&type=script&lang=js&"
export * from "./PersonalAccountDocUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3cd36",
  null
  
)

export default component.exports